export const travelTexts = [
  "Преодолели 2563 км самолётом и поездом - как от Самары до Магдебурга",
  "Привезли 110 кг багажа",
  "Проехали от 15 км до 25 км по канатным дорогам",
  "Гуляя по горам, прошли от 20 до 50 тысяч шагов",
  "Покорили разные высоты: 540, 650, 1100, 1389 и 2320 метров над уровнем моря",
];

export const travelIconsNames = [
  "plane",
  "lungage",
  "funicular",
  "footprints",
  "mountains",
];

export const weddingTexts = [
  "В день мероприятия:",
  "Съели 26 кг основных блюд и 3 кг торта",
  "Выпили 12 литров вина",
  "Использовали 300 единиц посуды",
  "Отчеканили 20 монет",
  "Загадали 10 главных пожеланий",
];

export const weddingIconsNames = [
  "arc",
  "cake",
  "wine",
  "dinner",
  "coins",
  "whishes",
];
